import * as React from 'react'
import { Box, Divider, Table } from '@mui/material';
import ListTablePagination, {ListTablePaginationProps} from './ListTablePagination'

interface Props {
    paginationProps?: ListTablePaginationProps
    children: React.ReactNode
}

const SortablePaginationTable: React.FC<Props> = props => {
    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, page: number): void => {
        if (!props.paginationProps) {
            return
        }
        props.paginationProps.onPageChange(event, page)
    }
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (!props.paginationProps) {
            return
        }
        if (!props.paginationProps.onRowsPerPageChange) {
            return
        }
        props.paginationProps.onRowsPerPageChange(event)
    }

    const listTablePagination = () => {
        if (!props.paginationProps) {
            return null
        }
        const {onPageChange, onRowsPerPageChange, ...rest} = props.paginationProps
        const paginationProps = {
            onPageChange: handleChangePage,
            onRowsPerPageChange: handleChangeRowsPerPage,
            ...rest,
        }
        return <ListTablePagination {...paginationProps} />
    }

    return (<Box mt={'10px'}>
        {listTablePagination()}
        <Divider/>
        <Table>
            {props.children}
        </Table>
        {listTablePagination()}
    </Box>)
}

export default SortablePaginationTable
